import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id 5D18BB49-3214-49C0-BD5C-B4581172C650
 * name serial-port
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/serial-port.svg
 * tags
 */
export const SerialPortIcon = createSvgIcon(<><path d="M7,3H17V5H19V8H16V14H8V8H5V5H7V3M17,9H19V14H17V9M11,15H13V22H11V15M5,9H7V14H5V9Z" /></>, 'SerialPortIcon');
export default SerialPortIcon